import {DealerEntityGroupMixRequest} from './dealer-group-mix-request';

export class DealerEntityMixRequestWrapper {
	userId: string;
	dealerEntityGroupMixRequest: DealerEntityGroupMixRequest[];
	marketKey: string;
  	vehicleLineCode: string;
  	wholesaleMonth: number;
  	productionMonth: string;
	ptvl: string;
	modelYear: number;
}
